module.exports = __webpack_public_path__ + "assets/LineAlongPointsDetailed.6f99eb1cd103bf4fa450f26952895985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LineAlongPointsDetailed.png
// module id = 535
// module chunks = 0